import InputNumber from 'aa_common/front-end/components/form/form-input-number'
import { defaultTo } from 'aa_common/front-end/helpers'
import { useNextEffect } from 'common/hooks/use-next-effect'
import { LedgerSettingsItem } from 'common/models'
import { useFormContext } from 'react-hook-form'

import { useGetAssetLedger } from '../hooks/use-get-asset-ledger'
import { useIsFullImpairment } from '../hooks/use-is-full-impairment'
import { AntInputAlignRight } from '../styles'
import { FIELD_NAMES } from '../validation'

const FieldName = FIELD_NAMES.impair_residual_value

type ImpairmentResidualProps = {
  ledgerSetting?: LedgerSettingsItem
}

export const ImpairmentResidual = ({ ledgerSetting }: ImpairmentResidualProps) => {
  const { setValue } = useFormContext()
  const assetLedger = useGetAssetLedger(ledgerSetting)

  const disabled = useIsFullImpairment()
  const defaultValue = defaultTo(assetLedger?.residual_amount, 0)

  useNextEffect(() => {
    disabled && setValue(FieldName, null, { shouldValidate: true })
    !disabled && setValue(FieldName, defaultValue, { shouldValidate: true })
  }, [setValue, disabled, defaultValue])

  return (
    <InputNumber
      name={FieldName}
      min={0}
      className={AntInputAlignRight}
      disabled={disabled}
      formatter={value => `¥${value}`}
      controls={false}
    />
  )
}
